import React, { Component } from "react";
import { connect } from "react-redux";
import DashboardUser from "./Dashboard/DashboardUser";
import moment from "moment";
import { assessmentActions, questionsActions } from "../../../../_actions";
import { FiSend, FiFileText, FiUsers, FiBarChart2 } from "react-icons/fi";
import { BsLightbulb } from "react-icons/bs";
import { LuThumbsUp, LuThumbsDown, LuCopy, LuCheck } from "react-icons/lu";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import { HiThumbUp, HiThumbDown } from "react-icons/hi";

const getTopAndBottomAssessments = (data = [], count = 5) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { top: [], bottom: [] };
  }

  return {
    top: data.slice(0, count).map(ele => ele?.dimension ?? ""),
    bottom: data.slice(-count).reverse().map(ele => ele?.dimension ?? "")
  };
};

class MyTeamOverallChat extends Component {
  constructor(props) {
    super(props);
    this.messagesEndRef = React.createRef();
    this.state = {
      pageName: "/assessment/myoverallteamchat",
      crrEmpId: "overall",
      textUser: "",
      crrTempText: "",
      isChatScreen: false,
      copied: "",
      isShow: true,
      crrTeamId: this.props.match.params.id
    };
  }

  componentDidMount() {
    this.runCode();
  }

  runCode = () => {
    this.props.dispatch(assessmentActions.getCoachProfile({}));
    this.props.dispatch(assessmentActions.getCoachTeamAssessmentReport({ teamId: this.state.crrTeamId }));
    // this.props.dispatch(assessmentActions.getAssessmentMngrTeamUSER());
    // this.props.dispatch(assessmentActions.getAssessmentMngrTeamStatus());
    this.props.dispatch(assessmentActions.getCoachTeamUserList({ teamId: this.state.crrTeamId }));
    this.props.dispatch(assessmentActions.getCoachTeamChatBookmark({
      chatType: "TEAM", emp_id: "overall", teamId: this.state.crrTeamId
    }, null, "FIRST"));
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.assessment.getCoachTeamChatTalentAIData !==
      this.props.assessment.getCoachTeamChatTalentAIData ||
      prevProps.assessment.loading !== this.props.assessment.loading
    ) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    setTimeout(() => {
      this.messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  setUserText = (value) => {
    this.setState({ textUser: value, isEffectCheck: false });
  };

  submitChatBot = (chatMarkIdInit, TeamAssessmentList) => {
    if (TeamAssessmentList) {
      const { questions, assessment } = this.props;
      const { textUser } = this.state;
      const { getCoachTeamAssessmentReportData: xList = [] } = assessment;

      if (!textUser.trim()) return;

      let AssessmentListX = []
      if (xList && xList.length > 0) {
        for (var j = 0; j < xList.length; j++) {
          let temp = xList[j];
          AssessmentListX.push(temp);
        }
        AssessmentListX.sort((b, a) => (a.finalSum - b.finalSum))
      }


      const { top, bottom } = getTopAndBottomAssessments(AssessmentListX);

      const { top: topTeam, bottom: bottomTeam } = getTopAndBottomAssessments(TeamAssessmentList);

      this.setState({ crrTempText: textUser, textUser: "", isChatScreen: true, isEffectCheck: true });

      const finalObj = {

        chatMarkId: chatMarkIdInit,
        question: textUser.trim(),

        topList: top,
        bottomList: bottom,

        topTeam: topTeam && topTeam.length > 0 ? topTeam : [],
        bottomTeam: bottomTeam && bottomTeam.length > 0 ? bottomTeam : [],

        isTeamAvailable: TeamAssessmentList && TeamAssessmentList.length > 0 ? true : false,
        emp_id: "overall", teamId: this.state.crrTeamId
      }

      console.log("finalObj--xd->", finalObj)
      this.props.dispatch(assessmentActions.saveCoachTeamChatTalentAI(finalObj, chatMarkIdInit));

    }
  };

  // ✅ Typing effect helper
  typeWriterEffect = (text, cb) => {
    let i = 0;
    const speed = 10;

    const interval = setInterval(() => {
      i++;
      cb(text.slice(0, i));
      if (i >= text.length) clearInterval(interval);
    }, speed);

    return () => clearInterval(interval);
  };


  onLogout = () => {
    this.props.dispatch(assessmentActions.coachLogout(this.props));
  }


  handleCopy = async (msgId, text) => {
    try {
      await navigator.clipboard.writeText(text);
      this.setState({ copied: msgId });

      setTimeout(() => {
        this.setState({ copied: "" });
      }, 1500);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };


  selectChatBookMark = (chatMarkId) => {
    if (chatMarkId === "new") {
      this.props.dispatch(assessmentActions.saveCoachTeamChatBookmark({ "type": "new", chatType: "TEAM", emp_id: "overall", teamId: this.state.crrTeamId }));
      this.setState({ chatMarkId: chatMarkId, isChatScreen: false });
    } else {
      this.props.dispatch(assessmentActions.getCoachTeamChatTalentAI({ chatMarkId: chatMarkId, chatType: "TEAM", emp_id: "overall", teamId: this.state.crrTeamId }));
      this.setState({ chatMarkId: chatMarkId });
    }
  }

  switchToAdmin = () => {
    this.props.history.push(`/assessment/overview`);
  };

  rateChatMsg = (msgId, review, chatMarkIdInit) => {
    let data = {
      chatId: msgId,
      review: review
    }
    this.props.dispatch(assessmentActions.rateChatResponse(data, chatMarkIdInit));
  }


  selectTeamEmp = (emp_id) => {
    this.setState({ crrEmpId: emp_id }, () => {
      let { crrTeamId, crrEmpId } = this.state;
      this.runCode();

      if (emp_id === "overall") {
        this.props.history.push(`/assessment/coachteamavira/` + crrTeamId);
      } else {
        this.props.history.push(`/assessment/coachavirabot/` + crrTeamId + "/" + crrEmpId);
      }
    });
  };


  render() {
    const { assessment, questions } = this.props;
    const { isShow, crrEmpId, textUser, crrTempText, isChatScreen, isEffectCheck, copied, chatMarkId } = this.state;
    const {
      loading,
      getCoachTeamChatTalentAIData = [],
      getCoachTeamChatBookmarkData = [],
      getCoachTeamUserListData: empXList = [],
      getAssessmentMngrTeamUSERData,
      getCoachProfileData = {},
      getCoachTeamAssessmentReportData: xList = []
    } = assessment;

    const empList = empXList && empXList.length > 0 ? empXList.map(ele => ({
      ...ele,
      name: (ele.name || "").trim().split(/\s+/)[0]
    })) : [];
    const {
      getAssessmenrEmployeeDetailsData,
    } = questions;

    const s = getCoachTeamChatBookmarkData;


    let TeamAssessmentList = [];
    if (getAssessmentMngrTeamUSERData?.Rank1) {
      TeamAssessmentList = Array.from(
        { length: 28 },
        (_, i) => ({
          dimension: getAssessmentMngrTeamUSERData[`Rank${i + 1}`]
        })
      ).filter(item => item.dimension);
    }


    let AssessmentListX = []
    if (xList && xList.length > 0) {
      for (var j = 0; j < xList.length; j++) {
        let temp = xList[j];
        AssessmentListX.push(temp);
      }
      AssessmentListX.sort((b, a) => (a.finalSum - b.finalSum))
    }
    console.log("AssessmentListX---new--->", AssessmentListX)
    console.log("xList---new--->", xList)

    // console.log("getAssessmentMngrTeamUSERData---new--->", getAssessmentMngrTeamUSERData)
    // console.log("TeamAssessmentList---new--->", TeamAssessmentList)

    const { top, bottom } = getTopAndBottomAssessments(AssessmentListX);
    const { top: topTeam, bottom: bottomTeam } = getTopAndBottomAssessments(TeamAssessmentList);

    console.log("Manager", top, bottom)
    console.log("Team", topTeam, bottomTeam)


    const chatList = [];
    getCoachTeamChatTalentAIData.forEach(ele => {
      chatList.push({ id: ele.id, text: ele.question, review: null, role: "user" });
      chatList.push({ id: ele.id, text: ele.response, review: ele && ele.review ? ele.review : null, role: "ai" });
    });


    const getPeriod = () => {
      const h = moment().hour();
      if (h < 12) return "Morning";
      if (h < 17) return "Afternoon";
      if (h < 21) return "Evening";
      return "Night";
    };

    function getFirstName(fullName) {
      return fullName ? fullName.trim().split(" ")[0] : "User";
    }
    const userDetails = { firstName: getFirstName(getCoachProfileData?.name), name: getCoachProfileData?.name, email: getCoachProfileData?.email, period: getPeriod() };



    const ActionButton = ({ icon, text, active, disabled }) => {
      return (
        <button
          disabled={disabled}
          className={`flex items-center gap-2 px-6 py-3 rounded-full shadow-md border
        ${active
              ? "bg-white border-[#1976D2] text-[#1976D2]"
              : "bg-white border-[#D1D5DB] text-gray-700"
            }
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-80"}
      `}
        >
          <span className="text-lg inherit text-current">
            {icon}
          </span>
          <span className="text-sm sm:text-base font-medium text-current">
            {text}
          </span>
        </button>
      );
    };



    const ChatbotLoaderButton = () => (
      <div className="flex justify-start my-4">
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-gray-100 animate-pulse">
          <span className="text-sm text-gray-600">Avira is thinking</span>
          <span className="flex gap-1">
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce" />
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce delay-150" />
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce delay-300" />
          </span>
        </div>
      </div>
    );

    // ✅ MessageBubble with typing effect
    const MessageBubble = ({ msgId, message, isAi, scrollIndex, typeIndex, chatMarkIdInit }) => {
      const [displayText, setDisplayText] = React.useState(
        isAi ? "" : message.text
      );

      React.useEffect(() => {
        if (isAi && message.text) {
          return this.typeWriterEffect(message.text, setDisplayText);
        }
      }, [message.text]);

      return (
        <div className={`flex mb-6 ${isAi ? "justify-start" : "justify-end"}`}>
          {!loading && scrollIndex && <div ref={this.messagesEndRef} />}
          <div>
            <div
              className={`px-4 py-3 rounded-2xl max-w-full ${isAi
                ? "bg-white text-gray-800 rounded-tl-none"
                : "bg-gray-200 rounded-tr-none"
                }`}
            >
              <p
                className="md:text-base text-sm leading-relaxed whitespace-pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: (typeIndex && isEffectCheck && !loading ? displayText : message.text).replace(
                    /\*\*(.*?)\*\*/g,
                    "<strong>$1</strong>"
                  )
                }}
              />
            </div>

            <div className="flex items-center gap-1.5 mt-2 text-gray-500">
              {isAi && (
                <>
                  <button onClick={() => this.rateChatMsg(msgId, "like", chatMarkIdInit)} className="p-2 rounded-md hover:bg-gray-100 transition">
                    {message.review === "like" ? <HiThumbUp size={19} /> : <LuThumbsUp size={18} />}
                  </button>
                  <button onClick={() => this.rateChatMsg(msgId, "dislike", chatMarkIdInit)} className="p-2 rounded-md hover:bg-gray-100 transition">
                    {message.review === "dislike" ? <HiThumbDown size={19} /> : <LuThumbsDown size={18} />}
                  </button>

                  <button onClick={() => {
                    this.setState({ isEffectCheck: false });
                    this.handleCopy(msgId, message.text);
                  }} className="p-2 rounded-md hover:bg-gray-100 transition">
                    {copied === msgId ? (
                      <div className="flex items-center gap-1.5">
                        <LuCheck size={17} />
                        <span className="text-xs">Copied</span>
                      </div>
                    ) : (
                      <LuCopy size={17} />
                    )}
                  </button>
                </>
              )}
              {/* <p className="text-xs text-center text-gray-600">Avira can make mistakes. check important info.</p> */}
            </div>
          </div>
        </div>
      );
    };



    let chatMarkIdInit = "";
    if (!(chatList.length > 0 || isChatScreen)) {
      chatMarkIdInit = "new"
    } else {
      chatMarkIdInit = chatMarkId && chatMarkId !== "new" ? chatMarkId : (s && s[0] && s[0]["id"] ? s[0]["id"] : "new");
    }

    // console.log("getCoachTeamChatTalentAIData-------->", getCoachTeamChatTalentAIData);
    // console.log("chatList-------->", chatList);
    // console.log("crrEmpId-------->", crrEmpId);

    const memberName = "Overall Team";
    console.log("chatList.length-------->", chatList.length);
    console.log("isChatScreen-------->", isChatScreen);
    return (
      <DashboardUser
        stage={5}
        crrEmpId={crrEmpId} memberName={memberName} selectTeamEmp={this.selectTeamEmp}
        userDetails={userDetails} onLogout={this.onLogout} isTeam={true} isNewChat={!(chatList.length > 0 || isChatScreen)}
        chatMarkIdInit={chatMarkIdInit} pageName={this.state.pageName} switchToAdmin={this.switchToAdmin}
        getChatBookmarkData={getCoachTeamChatBookmarkData} selectChatBookMark={this.selectChatBookMark}
        empList={empList}>


        {chatList.length > 0 || isChatScreen ? (
          <main className="flex flex-col h-full">
            <div className="flex-1 overflow-y-auto">
              <div className="max-w-4xl mx-auto">
                {chatList.map((msg, i) => (
                  <MessageBubble
                    key={i}
                    msgId={msg.id}
                    message={msg}
                    isAi={msg.role === "ai"}
                    scrollIndex={i + 1 === chatList.length - 1}
                    typeIndex={(msg.role === "ai") && (i + 1 === chatList.length)}
                    chatMarkIdInit={chatMarkIdInit}
                  />
                ))}

                {loading && crrTempText && (
                  <MessageBubble message={{ text: crrTempText }} isAi={false} />
                )}

                {loading && <ChatbotLoaderButton />}
                {loading && <div ref={this.messagesEndRef} />}
              </div>
            </div>

            <div className="max-w-4xl mx-auto w-full px-4 pb-4">
              <div className="relative">
                <input
                  value={textUser}
                  onChange={(e) => this.setUserText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && textUser.trim()) {
                      e.preventDefault();
                      this.submitChatBot(chatMarkIdInit, TeamAssessmentList);
                    }
                  }}
                  placeholder="Ask Avira"
                  className="w-full md:py-5 py-4 pl-6 pr-16 rounded-full shadow-lg bg-white backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-[#1976D2] transition border border-[#D1D5DB] text-lg" />
                <button
                  disabled={!textUser.trim() || loading}
                  onClick={() => this.submitChatBot(chatMarkIdInit, TeamAssessmentList)}
                  className="cursor-pointer absolute right-2 top-1/2 -translate-y-1/2 bg-gradient-to-r from-purple-600 to-blue-500 p-3 rounded-full text-white shadow-md hover:scale-105 transition">
                  <FiSend className="h-6 w-6 md:h-8 md:w-8" />
                </button>
              </div>
            </div>
          </main>
        ) : (
          <div className="min-h-screen flex items-center justify-center">
            <div className="w-full max-w-4xl text-left">
              {/* <h2 className="text-xl sm:text-2xl textblack font-medium"> For, {memberName} </h2> */}
              <div className="mt-4 textblack flex">
                <div className="">
                  <span class="rounded-full p-4 material-symbols-outlined mr-2 text-[1.5rem] bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white">
                    auto_awesome
                  </span>
                </div>
                <div>
                  <h1 className="sm:text-2xl md:text-3xl text-xl font-bold">Avira For Coach</h1>
                  <p className="text-base font-normal">The TalentPlus AI Companion</p>
                </div>
              </div>

              {top && top.length > 0 &&
                <p className="mt-8 textblack text-sm sm:text-base leading-relaxed text-left">
                  <p className="mt-8 textblack text-sm sm:text-base leading-relaxed text-left">
                    I am your Talent Digital Coach. You can ask me about your team member <span className="font-semibold">{memberName}'s</span> dominant talents -{" "}
                    <span className="font-semibold">
                      {top.join(", ")}
                    </span>{" "}
                    - as well as non-dominant talents -{" "}
                    <span className="font-semibold">
                      {bottom.join(", ")}.
                    </span>
                  </p>
                </p>}

              <div className="mt-10 relative w-full">
                <input
                  type="text"
                  placeholder="Ask Avira"
                  value={textUser}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && textUser.trim()) {
                      e.preventDefault();
                      this.submitChatBot(chatMarkIdInit, TeamAssessmentList);
                    }
                  }}
                  onChange={(e) => this.setUserText(e.target.value)}
                  className="w-full md:py-5 py-4 pl-6 pr-16 rounded-full shadow-lg bg-white backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-[#1976D2] transition border border-[#D1D5DB] text-lg" />
                <button onClick={() => this.submitChatBot(chatMarkIdInit, TeamAssessmentList)}
                  disabled={!isShow ? true : (top && top.length > 0 && (top && top.length > 0)) ? !textUser.trim() : true}
                  className="cursor-pointer absolute right-2 top-1/2 -translate-y-1/2 bg-gradient-to-r from-purple-600 to-blue-500 p-3 rounded-full text-white shadow-md hover:scale-105 transition">
                  <FiSend className="h-6 w-6 md:h-8 md:w-8" />
                </button>
              </div>

              <div className="mt-10 flex flex-wrap justify-center gap-4">
                <ActionButton icon={<FiFileText />} disabled={true} text="Explore TalentPlus" />
                {/*<ActionButton icon={<BsLightbulb />} disabled={true} text="Help me Learn" active />*/}
                <ActionButton icon={<BsLightbulb />} disabled={true} text="Help me Learn" />
                <ActionButton icon={<FiUsers />} disabled={true} text="Talk to Experts" />
                <ActionButton icon={<FiBarChart2 />} disabled={true} text="Reports" />
              </div>
            </div>
          </div>
        )
        }


      </DashboardUser>
    );
  }
}

const mapStateToProps = (state) => ({
  questions: state.questions,
  assessment: state.assessment
});

export default connect(mapStateToProps)(MyTeamOverallChat);
